import React from 'react';
import PropTypes from 'prop-types';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';
import CheckIcon from '@material-ui/icons/Check';

import FormField from './FormField';
import Version from '../../api/Version';


@observer
class VersionFormField extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    versions: PropTypes.arrayOf(PropTypes.instanceOf(Version)).isRequired,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    fullWidth: false,
    disabled: false,
    onChange: null,
  };

  @computed get options() {
    const { versions } = this.props;
    const options = [];
    for (const version of versions) {
      const option = (
        <Grid container spacing={2} justify="space-between" wrap="nowrap" alignItems="center">
          <Grid item>
            <Grid container spacing={2} wrap="nowrap">
              <Grid item><code>{version.cycleStr}</code></Grid>
              <Grid item>
                <CheckIcon fontSize="small" opacity={version.certified ? 1 : 0} />
              </Grid>
              <Grid item>{version.name}</Grid>
            </Grid>
          </Grid>
          <Grid item>
            <small>{version.verboseTechnologyFamily}</small>
          </Grid>
        </Grid>
      );
      options.push([version.id, option]);
    }
    return options;
  }

  render() {
    const { name, fullWidth, disabled, onChange } = this.props;
    return (
      <FormField
        name={name}
        options={this.options}
        variant="outlined"
        fullWidth={fullWidth}
        disabled={disabled}
        onChange={onChange}
      />
    );
  }
}


export default VersionFormField;
